import { Components, Theme } from '@mui/material';

export const sliderOverrides: Components<Theme>['MuiSlider'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.primary.light,
      height: 10,
      padding: '0',
      '& .MuiSlider-thumb': {
        height: 12,
        width: 12,
        backgroundColor: theme.palette.background.paper,
        border: `3px solid ${theme.palette.primary.light}`,
      },
      '& .MuiSlider-track': {
        border: 'none',
        height: 6,
      },
      '& .MuiSlider-rail': {
        backgroundColor: theme.palette.grey[300],
      },
    }),
  },
};
